import { Component, OnInit, Inject } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { map, of, switchMap } from 'rxjs';
@Component({
  selector: 'app-info-modal',
  templateUrl: './info-modal.component.html',
  styleUrls: ['./info-modal.component.css'],
})
export class InfoModalComponent {
  header: string;
  content: string;

  constructor(
    public dialogRef: MatDialogRef<InfoModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private translate: TranslateService
  ) {
    this.translate
      .get('phrases.' + data.header)
      .pipe(
        switchMap((translatedHeader: string) =>
          translatedHeader === 'phrases.' + data.header
            ? this.translate.get('words.' + data.header)
            : of(translatedHeader)
        )
      )
      .subscribe((translatedHeader: string) => {
        this.header = translatedHeader;
      });

    this.translate
      .get('phrases.' + data.content)
      .pipe(
        map((translatedContent: string) =>
          translatedContent === 'phrases.' + data.content
            ? data.content
            : translatedContent
        )
      )
      .subscribe((translatedContent: string) => {
        this.content = translatedContent;
      });
  }
}
